const operatorMenu = {
    "Квоты номеров": "room_quotas",
    Тарифы: "rates",
    "Правила отмены": "cancellation_policy",
    "Возвраты ДС": "refund",
    "Категории услуг": "service_categories",
    Услуги: "services",
    "Категории удобств": "room_feature_categories",
    Удобства: "room_features",
    "Стоимость проживания": "room_rates",
    "Уровни цен": "price_periods",
    // "Векторные цены и квоты": "vector_prices",
    Заявки: "reservations",
    "Запреты выезда": "banArrivals",
    "Срок проживания": "period_residence",
    "Толкование цен": "price_explanation",
    "Купленные услуги": "purchased_services",
    Промокоды: "promo",
    Отчеты: "reports",
    Служебные: "official",
    Подписки: "subscriptions",
};

const menu = {
    admin: {
        Компании: "companies",
        "Точки продаж": "places_sales",
        Отели: "hotels",
        Пользователи: "users",
        "Способы оплаты": "payment_methods",
        Конфигурация: "configurations",
        "Типы интерфейсов": "interface_types",
        Интерфейсы: "interfaces",
    },
    operator: {
        ...operatorMenu,
    },
    manager: {
        "Мои Отели": "hotels",
        "Категории номеров": "room_types",
        Операторы: "operators",
        ...operatorMenu,
        "Торговые группы": "market_groups",
        "Торговые коды": "market_codes",
        "Журнал PMS": "message_logs",
    },
    manager_export: {
        "Мои Отели": "hotels",
        Отчеты: "reports",
        Заявки: "reservations",
    },
};

export const getMenu = (userType) =>
    userType && menu[userType] ? menu[userType] : {};
